/**
 * FSM chooser (Object / State machine dropdowns above the FSM canvas).
 *
 * Changing the visible FSM used to call only `showFSM`, which swaps the
 * canvas and never updates `ui.selected`. The inspector reads `selected`, so
 * its contents stayed on the previous class. EDG clicks and explorer clicks
 * both select; the chooser must too.
 */

export type FsmChooserObjectType = {
  id: string;
  fsmForCodeGeneration?: { id: string } | null;
};

export type FsmChooserFlow = {
  getObjectTypeById(id: string): FsmChooserObjectType | undefined;
  showFSM(id: string): void;
  select(id: string): void;
};

export type FsmChooserChoice = { objectTypeId: string } | { fsmId: string };

export function applyFsmChooserChange(flow: FsmChooserFlow, choice: FsmChooserChoice): void {
  if ('objectTypeId' in choice) {
    const ot = flow.getObjectTypeById(choice.objectTypeId);
    if (ot == null) return;
    flow.select(ot.id);
    if (ot.fsmForCodeGeneration != null) {
      flow.showFSM(ot.fsmForCodeGeneration.id);
    }
    return;
  }
  flow.select(choice.fsmId);
  flow.showFSM(choice.fsmId);
}
